"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusTrap = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var DomUtil_1 = require("./DomUtil");
function handleFocus(e) {
    e.stopPropagation(); // just for TFS 739813 and 740525, c.f. PortalEventTrap
}
function handleBlur(e, onTrap) {
    var relatedTarget = DomUtil_1.findBlurRelatedTarget(e);
    if (relatedTarget && !e.currentTarget.contains(relatedTarget)) {
        e.target.focus();
        e.stopPropagation();
        if (onTrap) {
            onTrap(e);
        }
    }
}
/**
 * Prevents focus from leaving a container by re-focusing the previously focused element if it is determined that focus would leave the container.
 * Note: this does not work in firefox, which would require a settimeout() before re-focusing.
 * If this ever gets re-enabled for firefox, make sure to re-enable the unit tests.
 */
var FocusTrap = function (props) {
    var onTrap = props.onTrap, htmlAttrs = tslib_1.__rest(props, ["onTrap"]);
    var handleBlurCallback = React.useCallback(function (e) {
        handleBlur(e, onTrap);
    }, [onTrap]);
    return React.createElement("div", tslib_1.__assign({}, htmlAttrs, { onBlur: handleBlurCallback, onFocus: handleFocus, "data-focus-trap": '' }));
};
exports.FocusTrap = FocusTrap;
//# sourceMappingURL=FocusTrap.js.map